












































import Vue from "vue";
import StatusLine from "./StatusLine.vue";

const stepOption = [
  { label: "10分钟", value: "10m" },
  { label: "30分钟", value: "30m" },
  { label: "1小时", value: "1h" },
  { label: "1天", value: "24h" }
];

function toFixed(value: number, index = 2) {
  if (!value && value !== 0) return "";
  return value.toFixed(index).replace(".".padEnd(index + 1, "0"), "");
}

const monitor = [
  {
    title: "请求接收数(次/s)",
    type: "apiserver_request_rate",
    format: (value: string) => toFixed(parseFloat(value))
  },

  {
    title: "平均延时(s)",
    type: "apiserver_request_duration",
    format: (value: string) => toFixed(parseFloat(value))
  },
  // {
  //   title: "HTTP请求接收数(次/s)",
  //   type: "apiserver_request_by_verb_rate",
  //   format: (value: string) => toFixed(parseFloat(value)),
  //   groupBy,
  //   // legend: true
  // },
  // {
  //   title: "HTTP平均延时(s)",
  //   type: "apiserver_request_by_verb_duration",
  //   format: (value: string) => toFixed(parseFloat(value)),
  //   groupBy,
  //   // legend: true
  // },
  {
    title: "在线实例",
    type: "apiserver_up_sum"
  }
];

export default Vue.extend({
  name: "Api",
  components: { StatusLine },
  data() {
    return {
      date: [] as Array<Date>,
      step: "10m",
      stepOption,
      monitor
    };
  },
  mounted() {
    this.init();
    this.getData();
  },
  methods: {
    init() {
      const start = new Date();
      const end = new Date();

      start.setTime(start.getTime() - 3600 * 1000 * 2);
      // 默认选中 近两小时
      this.date = [start, end];
    },
    getData() {
      this.$nextTick(() => {
        (this.$refs.line as Vue[]).forEach(line => {
          (line as any).getData();
        });
      });
    },
    getDefaultData() {
      const now = new Date().getTime();
      switch (this.step) {
        case "10m":
          this.$set(this, "date", [
            new Date(now - 12 * 3600 * 1000),
            new Date(now)
          ]);
          break;
        case "30m":
          this.$set(this, "date", [
            new Date(now - 24 * 3600 * 1000),
            new Date(now)
          ]);
          break;
        case "1h":
          this.$set(this, "date", [
            new Date(now - 48 * 3600 * 1000),
            new Date(now)
          ]);
          break;
        case "24h":
          this.$set(this, "date", [
            new Date(now - 24 * 7 * 3600 * 1000),
            new Date(now)
          ]);
          break;
      }
      this.getData();
    }
  }
});
